var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"has-text-centered",domProps:{"textContent":_vm._s(_vm.$wording.resetpw.success_1)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$sprintf(_vm.$wording.resetpw.success_2, _vm.email))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }